import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=dbc2bfdc&"
import script from "./addDialog.vue?vue&type=script&lang=js&"
export * from "./addDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports